export class CounterHandler {
  interval = undefined;

  set(callback, ms) {
    this.interval = setInterval(callback, ms);
  }

  clear() {
    if (this.interval) clearInterval(this.interval);
  }
}
